import { render, staticRenderFns } from "./ModalServicos.vue?vue&type=template&id=0a4711bb&scoped=true&"
import script from "./ModalServicos.vue?vue&type=script&lang=js&"
export * from "./ModalServicos.vue?vue&type=script&lang=js&"
import style0 from "./ModalServicos.vue?vue&type=style&index=0&id=0a4711bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4711bb",
  null
  
)

export default component.exports